import React, { useState, useEffect, useCallback } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faUsers,
  faChevronRight,
  faSearch,
  faFilter,
  faTimes,
  faStar,
} from "@fortawesome/free-solid-svg-icons";

import "../../assets/css/custom.css";
import "../../assets/css/client.css";
import "../../assets/css/font-awesome.css";
import "../../assets/css/sweetalert.css";
import "../../assets/css/bootstrap.min.css";
import "../../assets/css/brand.css";
import  EditIcon from "../../assets/icons/maid-module-icons/blueEditIcon.svg"
import DigitalPassCard from "./modals/modals/DigitalPass";

import { commonAPI } from "../../services/CommonAPIService";
import AddStaffModal from "./component/AddStaffModal";
import AddMaidModal from "./modals/addMaidModal";
import EditModal from "./modals/EditModal";
import { ToastContainer } from "react-toastify";
import { toast } from "react-toastify";
import CrossIcon from "../../assets/icons/maid-module-icons/CrossIcon.svg";
import SortIcon from "../../assets/icons/maid-module-icons/SortIcon.svg"
import TransitReport from "./modals/modals/TransitReport";
import ImagePreviewModal from "./modals/modals/ImagePreviewModal";
import {ServiceIcons} from "../../assets/img/Society Roles/index"

const ServiceStaff = ({ staffData }) => {
  const [showListModal, setShowListModal] = useState(false);
  const [showCategoryModal, setShowCategoryModal] = useState(false);
  const [showFormModal, setShowFormModal] = useState(false);
  const [selectedRoleForForm, setSelectedRoleForForm] = useState(null);
  const [showEditModal, setShowEditModal] = useState(false);
  const [selectedStaffId, setSelectedStaffId] = useState(null);

  const [stats, setStats] = useState([]);
  const [loadingStats, setLoadingStats] = useState(false);

  const [mainSearchTerm, setMainSearchTerm] = useState("");

  const [selectedRoleId, setSelectedRoleId] = useState(null);
  const [staffList, setStaffList] = useState([]);
  const [loadingStaff, setLoadingStaff] = useState(false);
  const [staffError, setStaffError] = useState(null);
  const [totalRecords, setTotalRecords] = useState(0);
  const [selectedRole,setSelectedRole]=useState(null);

  // Department states
  const [departments, setDepartments] = useState([]);
  const [selectedDepartmentId, setSelectedDepartmentId] = useState(""); 
  const [loadingDepartments, setLoadingDepartments] = useState(false);

  // Applied filters
  const [filterGender, setFilterGender] = useState("All");
  const [filterStatus, setFilterStatus] = useState("All");
  const [filterRating, setFilterRating] = useState("All");

  // Draft filters
  const [draftGender, setDraftGender] = useState("All");
  const [draftStatus, setDraftStatus] = useState("All");
  const [draftRating, setDraftRating] = useState("All");

  const [modalSearchTerm, setModalSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize] = useState(10);

  const [showFilterModal, setShowFilterModal] = useState(false);
  const [fetchTimeout, setFetchTimeout] = useState(null);
  const [displayedStaff, setDisplayedStaff] = useState([]);
  
  //Sorting
  const [sortOrder, setSortOrder] = useState("asc");

  // Transit Report
  const [showTransit,setShowTransit]=useState(false);

  const [showDigitalPass, setShowDigitalPass] = useState(false);
  const [digitalPassData, setDigitalPassData] = useState(null);
  const [loadingPass, setLoadingPass] = useState(false);
  
  const [selectedStaffForImage, setSelectedStaffForImage] = useState(null);

  const [showMasked, setShowMasked] = useState(false);
const [settingsLoading, setSettingsLoading] = useState(true);


// Fetch departments once
useEffect(() => {
  const fetchDepartments = async () => {
    const auth = localStorage.getItem("userData");
    if (!auth) return;

    const myUserData = JSON.parse(auth);

    setLoadingDepartments(true);

    try {
      const response = await commonAPI("Department", undefined, {
        buildingId: myUserData?.buildingId,
      });

      if (response?.success) {
        setDepartments(response.data || []);
      } else {
        throw new Error(response?.message || "Failed to load departments");
      }

    } catch (error) {
      console.error("Department Fetch Error:", error);

      const bodyError = {
        userId: myUserData?.userId || null,
        mobileNumber: myUserData?.mobileNumber || null,
        requestJSON: null,
        uri: "/api/Master/Department",
        errorSource: "CuroNextPortal",
        errorNumber: "SRVCSTF01",
        errorSummary: error?.message,
        errorDescription: JSON.stringify(error),
        fileClassName: "ServiceStaff.js",
        functionName: "fetchDepartments",
      };

      try {
        await commonAPI("ErrorLogMaster", bodyError);
      } catch (logErr) {
        console.error("Error while logging error:", logErr);
      }

      toast.error(error?.message || "Error loading departments");
    } finally {
      setLoadingDepartments(false);
    }
  };

  fetchDepartments();
}, []);

  // Fetch stats when department or main search changes


 const fetchServiceStaffStats = async () => {
  const auth = localStorage.getItem("userData");
  if (!auth) return;

  const myUserData = JSON.parse(auth);

  setLoadingStats(true);

  try {
    const response = await commonAPI("ServiceStaffStats", undefined, {
      buildingId: myUserData?.buildingId,
      urlVariable: selectedDepartmentId || undefined,
    });

    if (response?.success) {
      setStats(response.data || []);
    } else {
      throw new Error(response?.message || "Failed to fetch staff stats");
    }

  } catch (error) {
    console.error("ServiceStaffStats Error:", error);

    const bodyError = {
      userId: myUserData?.userId || null,
      mobileNumber: myUserData?.mobileNumber || null,
      requestJSON: JSON.stringify({
        selectedDepartmentId: selectedDepartmentId || null,
      }),
      uri: "/api/User/ServiceStaffStats",
      errorSource: "CuroNextPortal",
      errorNumber: "SRVCSTF02",
      errorSummary: error?.message,
      errorDescription: JSON.stringify(error),
      fileClassName: "ServiceStaff.js",
      functionName: "fetchServiceStaffStats",
    };

    try {
      await commonAPI("ErrorLogMaster", bodyError);
    } catch (logErr) {
      console.error("Error while logging error:", logErr);
    }

    toast.error(error?.message || "Error fetching staff stats");
  } finally {
    setLoadingStats(false);
  }
};


 useEffect(() => {
  if (!selectedDepartmentId) {
    setStats([]);
    setLoadingStats(false); 
    return;
  }

  fetchServiceStaffStats();
}, [selectedDepartmentId, showEditModal]);


 const fetchServiceStaffList = useCallback(async (roleId = null) => {
  const auth = localStorage.getItem("userData");
  if (!auth) return;

  const myUserData = JSON.parse(auth);

  setLoadingStaff(true);
  setStaffError(null);

  let requestPayload = null;

  try {
    requestPayload = {
      userName: modalSearchTerm.trim() || "",
      gender: filterGender === "All" ? "" : filterGender,
      roleId: roleId ?? 0,
      isCurrentlyIn:
        filterStatus === "All" ? null :
        filterStatus === "Inside" ? true :
        filterStatus === "Outside" ? false : null,
      rating:
        filterRating === "All" ? 0 :
        filterRating === "3+" ? 3 :
        filterRating === "4+" ? 4 : 0,
      isPaging: true,
      isLazyLoading: true,
      pageNumber: currentPage - 1,
      pageSize: pageSize,
    };

    const response = await commonAPI("ServiceStaffList", requestPayload, {
      buildingId: myUserData?.buildingId,
      departmentId: selectedDepartmentId || undefined,
    });

    if (response?.success) {
      const data = response.data || {};
      const list = data.serviceStaffList || [];
      const total = Number(data.recordCount ?? 0);

      setTotalRecords(total);
      setStaffList(list);
    } else {
      throw new Error(response?.message || "Failed to load staff list");
    }

  } catch (error) {
    console.error("ServiceStaffList Error:", error);

    const bodyError = {
      userId: myUserData?.userId || null,
      mobileNumber: myUserData?.mobileNumber || null,
      requestJSON: JSON.stringify(requestPayload),
      uri: "/api/User/ServiceStaffList",
      errorSource: "CuroNextPortal",
      errorNumber: "SRVCSTF03",
      errorSummary: error?.message,
      errorDescription: JSON.stringify(error),
      fileClassName: "ServiceStaff.js",
      functionName: "fetchServiceStaffList",
    };

    try {
      await commonAPI("ErrorLogMaster", bodyError);
    } catch (logErr) {
      console.error("Error while logging error:", logErr);
    }

    setStaffError(error?.message || "Something went wrong while loading staff");
    setTotalRecords(0);
    setStaffList([]);
  } finally {
    setLoadingStaff(false);
  }
}, [
  modalSearchTerm,
  filterGender,
  filterStatus,
  filterRating,
  currentPage,
  pageSize,
  selectedDepartmentId,
]);
  // Client-side filtering (mainly for modal search)
  useEffect(() => {
    if (!staffList?.length) {
      setDisplayedStaff([]);
      return;
    }

    if (!modalSearchTerm?.trim()) {
      setDisplayedStaff([...staffList]);
      return;
    }

    const term = modalSearchTerm.toLowerCase().trim();

    const filtered = staffList.filter((staff) => {
      const nameMatch = staff.userName?.toLowerCase().includes(term) ?? false;
      const mobileMatch = staff.mobileNumber?.toLowerCase().includes(term) ?? false;
      const houseMatch = staff.houseNames?.some((h) => h?.toLowerCase().includes(term)) ?? false;
      return nameMatch || mobileMatch || houseMatch;
    });

    setDisplayedStaff(filtered);
  }, [staffList, modalSearchTerm]);

  // Reset and fetch when modal opens 
  useEffect(() => {
    if (showListModal) {
      setCurrentPage(1);
      setModalSearchTerm("");
      setFilterGender("All");
      setFilterStatus("All");
      setFilterRating("All");
      setTotalRecords(0);
      fetchServiceStaffList(selectedRoleId);
    } else {
      setStaffList([]);
      setTotalRecords(0);
      setCurrentPage(1);
      if (fetchTimeout) clearTimeout(fetchTimeout);
    }
  }, [showListModal, selectedRoleId, selectedDepartmentId]);

  // Debounced fetch for filters / pagination changes
  useEffect(() => {
    if (!showListModal) return;

    if (fetchTimeout) clearTimeout(fetchTimeout);

    const timeoutId = setTimeout(() => {
      fetchServiceStaffList(selectedRoleId);
    }, 350);

    setFetchTimeout(timeoutId);

    return () => clearTimeout(timeoutId);
  }, [
    currentPage,
    filterGender,
    filterStatus,
    filterRating,
    modalSearchTerm,
    selectedRoleId,
    showListModal,
    fetchServiceStaffList,
  ]);

  const openFilterModal = () => {
    setDraftGender(filterGender);
    setDraftStatus(filterStatus);
    setDraftRating(filterRating);
    setShowFilterModal(true);
  };

  const applyFilters = () => {
    setFilterGender(draftGender);
    setFilterStatus(draftStatus);
    setFilterRating(draftRating);
    setCurrentPage(1);
    setShowFilterModal(false);
  };

  const resetFilters = () => {
    setDraftGender("All");
    setDraftStatus("All");
    setDraftRating("All");
  };

  const clearAllFilters = () => {
    setFilterGender("All");
    setFilterStatus("All");
    setFilterRating("All");
    setModalSearchTerm("");
    setCurrentPage(1);
  };

  const renderStars = (rating) => {
    const ratingNum = Number(rating) || 0;
    return Array.from({ length: 5 }, (_, i) => (
      <FontAwesomeIcon
        key={i}
        icon={faStar}
        className={i < ratingNum ? "text-warning" : "text-muted"}
        style={{ fontSize: "0.75rem" }}
      />
    ));
  };

  const totalPages = Math.max(1, Math.ceil(totalRecords / pageSize));

  const goToPage = useCallback((page) => {
    if (page < 1 || page > totalPages || page === currentPage) return;
    setCurrentPage(page);
  }, [currentPage, totalPages]);

  const handleEditClick = (staffId) => {
    setSelectedStaffId(staffId);
    setShowEditModal(true);
  };

  const handleCloseEditModal = () => {
    setShowEditModal(false);
    setSelectedStaffId(null);
  };

  const visibleStats = stats.filter((item) => {
    if (!mainSearchTerm.trim()) return true;
    const term = mainSearchTerm.toLowerCase().trim();
    return (
      item.roleName?.toLowerCase().includes(term) ||
      String(item.count || 0).includes(term)
    );
  });

  const handleTileClick = (roleId,role ) => {
    setSelectedRoleId(roleId);
    setSelectedRole(role);
    sessionStorage.setItem("selectedRoleId", roleId);
     sessionStorage.setItem("selectedRole", role);
    setCurrentPage(1);
    setShowListModal(true);
  };

  const handleAddStaffClick = () => {
    setShowCategoryModal(true);
  };

  const handleRoleSelected = (role) => {
    setSelectedRoleForForm(role);
    setShowCategoryModal(false);
    setShowFormModal(true);
  };

  useEffect(() => {
    if (showListModal) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
    return () => {
      document.body.style.overflow = "auto";
    };
  }, [showListModal]);


const handleSort = () => {
  setSortOrder(prev => (prev === "asc" ? "desc" : "asc"));
};

const processedStaff = [...staffList]
  .filter((staff) => {
    if (!modalSearchTerm.trim()) return true;

    const term = modalSearchTerm.toLowerCase().trim();

    return (
      staff.userName?.toLowerCase().includes(term) ||
      staff.mobileNumber?.toLowerCase().includes(term) ||
      staff.houseNames?.some((h) =>
        h?.toLowerCase().includes(term)
      )
    );
  })
  .sort((a, b) => {
    const nameA = (a.userName || "").trim().toLowerCase();
    const nameB = (b.userName || "").trim().toLowerCase();

    return sortOrder === "asc"
      ? nameA.localeCompare(nameB)
      : nameB.localeCompare(nameA);
  });


const handleViewPass = async (staffId) => {
  setShowDigitalPass(true);
  setLoadingPass(true);

  const auth = localStorage.getItem("userData");
  if (!auth) {
    setLoadingPass(false);
    return;
  }

  const myUserData = JSON.parse(auth);
  let requestPayload = { staffId };

  try {
    const response = await commonAPI(
      "GetServiceStaffDetail",
      requestPayload,
      { buildingId: myUserData?.buildingId }
    );

    if (response?.success) {
      setDigitalPassData(response.data);
    } else {
      throw new Error(response?.message || "Failed to fetch digital pass");
    }

  } catch (error) {
    console.error("GetServiceStaffDetail (Pass) Error:", error);

    const bodyError = {
      userId: myUserData?.userId || null,
      mobileNumber: myUserData?.mobileNumber || null,
      requestJSON: JSON.stringify(requestPayload),
      uri: "/api/Master/GetServiceStaffDetail",
      errorSource: "CuroNextPortal",
      errorNumber: "SRVCSTF04",
      errorSummary: error?.message,
      errorDescription: JSON.stringify(error),
      fileClassName: "ServiceStaff.js",
      functionName: "handleViewPass",
    };

    try {
      await commonAPI("ErrorLogMaster", bodyError);
    } catch (logErr) {
      console.error("Error while logging error:", logErr);
    }

    toast.error(error?.message || "Error fetching digital pass");
  } finally {
    setLoadingPass(false);
  }
};

useEffect(() => {
  const loadSetting = async () => {
    try {
      const auth = localStorage.getItem("userData");
      if (!auth) {
        setSettingsLoading(false);
        return;
      }
      const myUserData = JSON.parse(auth);
      if (!myUserData?.buildingId) {
        setSettingsLoading(false);
        return;
      }

      const response = await commonAPI("AppSettings", undefined, {
        buildingId: myUserData.buildingId,
      });

      if (response?.success === true && Array.isArray(response.data)) {
        const setting = response.data.find(item => item.key === "SERVICE_STAFF_MOBILE_NBR_DIALER_VISIBILITY");
        const roles = setting?.value?.toLowerCase()?.split("|") || [];
        setShowMasked(!roles.includes("admin"));
      } else {
        setShowMasked(false);
      }
    } catch {
      setShowMasked(false);
    } finally {
      setSettingsLoading(false);
    }
  };
  loadSetting();
}, []);


const maskMobileNumber = (number) => {
  if (!number) return "—";
  const str = String(number);
  if (str.length < 4) return str;
  return str.slice(0, 2) + "*".repeat(str.length - 4) + str.slice(-2);
};

  return (
    <>
      <ToastContainer />

      {/* Header + Search + Department Dropdown */}
      <div className="row mb-4 mt-5 pt-3 align-items-start g-3">
        <div className="col-md-5">
          <div className="HeadingTop" style={{ marginTop: "5px" }}>
            <h3 className="mb-1">Service Staff</h3>
            <span style={{ whiteSpace: "nowrap" }}>
              Daily Workforce: Maids, Helpers & Service Providers
            </span>
          </div>
        </div>

          <div className="col-md-7">
            <div className="d-flex gap-3 align-items-start justify-content-end flex-nowrap" style={{marginTop:"5px"}}>

              {/* Search */}
              <div
                className="input-group shadow-sm rounded-pill overflow-hidden position-relative"
                style={{ maxWidth: "200px" }}
              >
                <span className="input-group-text bg-white border-0 ps-3">
                  <FontAwesomeIcon icon={faSearch} className="text-muted" />
                </span>
                <input
                  type="text"
                  className="form-control border-0 py-2"
                  placeholder="Search by role"
                  value={mainSearchTerm}
                  onChange={(e) => setMainSearchTerm(e.target.value)}
                />
                {mainSearchTerm && (
                  <button
                    className="btn border-0 position-absolute end-0 top-50 translate-middle-y px-3 text-muted"
                    onClick={() => setMainSearchTerm("")}
                  >
                    <FontAwesomeIcon icon={faTimes} />
                  </button>
                )}
              </div>

             
            {/* Department */}
            <select
              className="form-select shadow-sm py-1"
              style={{ maxWidth: "200px", marginTop: "-3px" }}
              value={selectedDepartmentId}
              onChange={(e) => {
                setSelectedDepartmentId(e.target.value);
                setCurrentPage(1);
              }}
            >
              <option value="">Select Department</option>
              {departments.map((dept) => (
                <option
                  key={dept.departmentId}
                  value={dept.departmentId}
                >
                  {dept.departmentName}
                </option>
              ))}
            </select>

            {/* Add Button */}
            <button
              className="btn btn-sm px-3"
              style={{ background: "#3195D3", color: "#FFFFFF" }}
              onClick={handleAddStaffClick}
            >
              + Create New
            </button>
          </div>
        </div>
      </div>

      {/* Stats Tiles */}
      {loadingStats ? (
        <div className="text-center my-5">
          <div className="spinner-border text-primary" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>
      ) : visibleStats.length === 0 ? (
        <div className="text-center my-5 py-5 bg-light rounded-3">
          <div className="mb-4">
            <FontAwesomeIcon
              icon={faUsers}
              className="text-muted"
              style={{ fontSize: "4.5rem", opacity: 0.35 }}
            />
          </div>
            <p className="text-muted mb-4">
            {mainSearchTerm.trim()
              ? `No roles match "${mainSearchTerm}"`
              : selectedDepartmentId
              ? "No staff found in selected department"
              : ""}
          </p>
          {mainSearchTerm.trim() && (
            <button
              className="btn btn-outline-primary rounded-pill px-4"
              onClick={() => setMainSearchTerm("")}
            >
              Clear search
            </button>
          )}
        </div>
      ) : (
        <div className="row g-3">
          {visibleStats.map((item) => {
           const code = item.imageIconUrl || "";
            const iconSrc = ServiceIcons[code] || ServiceIcons.default;

            return (
              <div key={item.roleId} className="col-6 col-md-4 col-lg-3 col-xl-2">
                <div
                  className="card border shadow-sm h-100 p-0"
                  style={{ cursor: "pointer", minHeight: "76px", background: "#ECECEC" }}
                  onClick={() => handleTileClick(item.roleId,item.roleName)}
                >
                  <div className="card-body p-3 d-flex align-items-center justify-content-between">
                    <div className="d-flex align-items-center">
                      <img
                        src={iconSrc}
                        alt={item.roleName || "role"}
                        style={{
                          width: "32px",
                          height: "32px",
                          marginRight: "12px",
                          objectFit: "contain",
                        }}
                      />
                      <div>
                        <div className="fw-bold" style={{ fontSize: "15px" }}>
                          {item.roleName}
                        </div>
                        <div className="d-flex align-items-center mt-1">
                          <strong style={{ fontSize: "20px" }}>{item.count || 0}</strong>
                          <FontAwesomeIcon
                            icon={faChevronRight}
                            className="ms-2 text-muted"
                            style={{ fontSize: "12px" }}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      )}

      {/* Staff List Modal */}
      <div
        className={`modal fade ${showListModal ? "show" : ""}`}
        style={{ display: showListModal ? "block" : "none" }}
        tabIndex="-1"
      >
        <div className="modal-dialog modal-fullscreen">
          <div className="modal-content">
            <div className="modal-header border-0" style={{ backgroundColor: "#2e333f" }}>
              <h5 className="modal-title fw-bold fs-4 text-white">
                Service Staff
              </h5>
              <button
              className="btn p-0 d-flex align-items-center justify-content-center bg-white"
              style={{
                width: 24,
                height: 24,
                borderRadius: 6,
                flexShrink: 0,
              }}
              onClick={() => setShowListModal(false)}
            >
              <img src={CrossIcon} alt="cross" />
            </button>
            </div>

            <div className="modal-body" style={{ background: "#FFFFFF" }}>
              <div className="d-flex flex-column flex-sm-row justify-content-between align-items-center mb-3 gap-3 pb-3 border-bottom flex-wrap">
                <h5 className="fw-bold fs-4" style={{ color: "#000000" }}>
                  {selectedRoleId
                    ? stats.find((s) => s.roleId === selectedRoleId)?.roleName || "Staff List"
                    : "All Service Staff"}
                </h5>

                <div className="d-flex flex-nowrap align-items-center gap-2 justify-content-end w-100" style={{ marginTop: "-35px" }}>
                  <div
                    className="input-group shadow-sm rounded-pill overflow-hidden"
                    style={{ width: "320px" }}
                  >
                    <span
                      className="input-group-text bg-white border-0 d-flex align-items-center justify-content-center"
                      style={{ width: "50px" }}
                    >
                      <FontAwesomeIcon icon={faSearch} className="text-muted" />
                    </span>

                    <input
                      type="text"
                      className="form-control border-0"
                      placeholder="Search by name"
                      value={modalSearchTerm}
                      onChange={(e) => {
                        setModalSearchTerm(e.target.value);
                        setCurrentPage(1);
                      }}
                    />

                    {modalSearchTerm && (
                      <button
                        className="btn border-0 px-3"
                        onClick={() => {
                          setModalSearchTerm("");
                          setCurrentPage(1);
                        }}
                      >
                        <FontAwesomeIcon icon={faTimes} className="text-muted" />
                      </button>
                    )}
                  </div>

                  <button
                    className="btn btn-outline-primary btn-sm px-4 rounded-pill d-flex align-items-center gap-2"
                    onClick={openFilterModal}
                  >
                    <FontAwesomeIcon icon={faFilter} />
                    Filter
                  </button>
                  <button
                    onClick={() => setShowTransit(true)}
                    style={{
                      background: "none",
                      border: "none",
                      padding: 0,
                      marginLeft: "16px",
                      color: "#0578A6",
                      cursor: "pointer",
                      fontWeight: 600
                    }}
                  >
                    <span
                      style={{
                        fontSize: "15px", 
                        textTransform: "none"
                      }}
                    >
                      Transit Report
                    </span>
                  </button>

                </div>
              </div>

              {loadingStaff ? (
                <div className="text-center my-5">
                  <div className="spinner-border text-primary" role="status">
                    <span className="visually-hidden">Loading...</span>
                  </div>
                </div>
              ) : staffError ? (
                <div className="alert alert-danger text-center">{staffError}</div>
              ) : staffList.length === 0 ? (
                <div className="alert alert-info text-center py-5">
                  {modalSearchTerm.trim()
                    ? `No staff matches "${modalSearchTerm}"`
                    : "No staff members found matching current filters"}
                </div>
              ) : (
                <>
              <div className="table-responsive" style={{ height: 400, background: "#FFFFFF", marginTop: "-15px" }}>
                <table className="table table-hover align-middle">
                  <thead className="table-light">
                    <tr>
                      <th style={{ textTransform: 'none' }}>
                        <button 
                          onClick={handleSort}
                          style={{ 
                            background: 'none',
                            border: 'none',
                            cursor: 'pointer',
                            display: 'flex',
                            alignItems: 'center',
                            padding: 0,
                            color: '#191919',
                            textTransform: 'none',                
                          }}
                        >
                            <span style={{ textTransform: 'none' }}>Name</span>
                                       <img 
                                        src={SortIcon} 
                                        alt="Sort"
                                        style={{ 
                                          marginLeft: '8px',
                                          transition: 'transform 0.3s ease',
                                          transform: sortOrder === "asc" 
                                            ? "rotate(0deg)" 
                                            : "rotate(180deg)"
                                        }} 
                                      />

              <span style={{ color: '#318C9D', marginLeft: '4px' }}>
                {sortOrder === "asc" ? "A-Z" : "Z-A"}
              </span>
                        </button>
                      </th>
                      <th>Mobile Number</th>
                      <th>Flat</th>
                      <th>In/Out</th>
                      <th>Digital Pass</th>
                      <th style={{ width: "90px" }}>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {processedStaff.map((staff) => (
                      <tr key={staff.staffId || staff.userId || staff.mobileNumber}>
                        <td className="fw-medium">
                          <div style={{ display: 'flex', alignItems: 'center' }}>
                            {staff.userImageURL ? (
                              <img
                                src={staff.userImageURL}
                                alt={staff.userName || "Staff"}
                                className="rounded-circle"
                                onClick={() => setSelectedStaffForImage(staff)}  
                                style={{ width: "48px", height: "48px", objectFit: "cover", cursor: "pointer", marginRight: "10px" }}  
                              />
                            ) : null}
                          <div>
                            <div>{staff.userName || "—"}</div>
                            <div>{renderStars(staff.rating)}</div>
                          </div>
                        </div>
                      </td>
                      <td>
                        {settingsLoading
                          ? "..."
                          : showMasked
                          ? maskMobileNumber(staff.mobileNumber)
                          : staff.mobileNumber || "—"}
                      </td>
                      <td>
                        <div className="d-flex flex-wrap gap-1 align-items-center">
                          {staff.houseNames?.slice(0, 2).map((houseName, idx) => (
                            <span
                              key={idx}
                              className="badge text-black rounded-pill px-4 py-2 text-nowrap "
                              style={{ fontSize: '14px', fontWeight: 700, border: "1px solid #DEDEDE", background: "#F8F8F8" }}
                            >
                              {houseName}
                            </span>
                          ))}

                          {/* Show +N for remaining */}
                          {staff.houseNames?.length > 2 && (
                            <span
                              className=" text-black text-nowrap"
                              style={{ fontSize: '13px', fontWeight: 500 }}
                            >
                              +{staff.houseNames.length - 2}
                            </span>
                          )}

                          {/* Fallback if no houses */}
                          {(!staff.houseNames || staff.houseNames.length === 0) && (
                            <span>
                              -
                            </span>
                          )}
                        </div>
                      </td>
                      <td>
                        <span
                          className={`badge px-3 py-2 rounded-pill ${
                            staff.isCurrentlyIn
                              ? "bg-success-subtle text-success border border-success"
                              : "bg-danger-subtle text-danger border border-danger"
                          }`}
                        >
                          {staff.isCurrentlyIn ? "Inside" : "Outside"}
                        </span>
                      </td>
                      
                      <td>
                        <span
                          style={{ color: "#1C6CAD", cursor: "pointer", fontWeight: 500 }}
                          onClick={() => handleViewPass(staff.staffId)}
                        >
                          View Pass
                        </span>
                      </td>

                      <td>
                        <button
                          onClick={() => handleEditClick(staff.staffId)}
                          style={{
                            background: "none",
                            border: "none",
                            padding: 0,
                            display: "flex",
                            alignItems: "center",
                            gap: "6px",
                            color: "#1C80D2",
                            cursor: "pointer",
                            textTransform: "none" 
                          }}
                        >
                          <span style={{ textTransform: "none" }}>
                            Edit
                          </span>
                          <img
                            src={EditIcon}
                            alt="Edit"
                            style={{
                              width: "16px",
                              height: "16px"
                            }}
                          />
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
                              {/* Pagination */}
                  <div className="d-flex flex-column flex-md-row justify-content-between align-items-center mt-4 gap-3 px-2">
                    <div className="text-muted small">
                      Showing{" "}
                      <strong>
                        {totalRecords === 0 ? 0 : (currentPage - 1) * pageSize + 1}
                      </strong>{" "}
                      –{" "}
                      <strong>
                        {Math.min(currentPage * pageSize, totalRecords)}
                      </strong>{" "}
                      of <strong>{totalRecords.toLocaleString()}</strong>
                      {modalSearchTerm.trim() && " (filtered)"}
                    </div>

                    {totalPages > 1 && (
                      <nav aria-label="Staff list pagination">
                        <ul className="pagination pagination-sm mb-0 flex-wrap">
                          <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
                            <button
                              className="page-link rounded-start-pill px-3"
                              onClick={() => goToPage(currentPage - 1)}
                              disabled={currentPage === 1}
                            >
                              ← Prev
                            </button>
                          </li>

                          {Array.from({ length: totalPages }, (_, i) => i + 1)
                            .filter(
                              (p) =>
                                p === 1 ||
                                p === totalPages ||
                                (p >= currentPage - 2 && p <= currentPage + 2)
                            )
                            .reduce((acc, p, idx, arr) => {
                              if (idx > 0 && p > arr[idx - 1] + 1) {
                                acc.push("...");
                              }
                              acc.push(p);
                              return acc;
                            }, [])
                            .map((pageNum, idx) =>
                              pageNum === "..." ? (
                                <li key={`ellipsis-${idx}`} className="page-item disabled">
                                  <span className="page-link px-3">…</span>
                                </li>
                              ) : (
                                <li
                                  key={pageNum}
                                  className={`page-item ${pageNum === currentPage ? "active" : ""}`}
                                >
                                  <button
                                    className="page-link px-3"
                                    onClick={() => goToPage(pageNum)}
                                  >
                                    {pageNum}
                                  </button>
                                </li>
                              )
                            )}

                          <li className={`page-item ${currentPage === totalPages ? "disabled" : ""}`}>
                            <button
                              className="page-link rounded-end-pill px-3"
                              onClick={() => goToPage(currentPage + 1)}
                              disabled={currentPage === totalPages}
                            >
                              Next →
                            </button>
                          </li>
                        </ul>
                      </nav>
                    )}
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      </div>

      {/* Filter Modal */}
      {showFilterModal && (
        <div
          className="modal fade show"
          style={{ display: "block", backgroundColor: "rgba(0,0,0,0.5)", zIndex: 1070 }}
          tabIndex="-1"
        >
          <div className="modal-dialog modal-dialog-centered modal-sm">
            <div className="modal-content rounded-3 shadow-lg">
              <div className="modal-header">
                <h5 className="modal-title fw-bold">Fillters</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setShowFilterModal(false)}
                />
              </div>
              <div className="modal-body">
                <div className="mb-3">
                  <label className="form-label fw-medium">Status</label>
                  <select
                    className="form-select"
                    value={draftStatus}
                    onChange={(e) => setDraftStatus(e.target.value)}
                  >
                    <option value="All">All</option>
                    <option value="Inside">Inside</option>
                    <option value="Outside">Outside</option>
                  </select>
                </div>


                <div className="mb-3">
                  <label className="form-label fw-medium">Gender</label>
                  <select
                    className="form-select"
                    value={draftGender}
                    onChange={(e) => setDraftGender(e.target.value)}
                  >
                    <option value="All">All</option>
                    <option value="Male">Male</option>
                    <option value="Female">Female</option>
                    <option value="Other">Other</option>
                  </select>
                </div>

                <div className="mb-3">
                  <label className="form-label fw-medium">Rating</label>
                  <select
                    className="form-select"
                    value={draftRating}
                    onChange={(e) => setDraftRating(e.target.value)}
                  >
                    <option value="All">All</option>
                    <option value="3+">3+ Stars</option>
                    <option value="4+">4+ Stars</option>
                  </select>
                </div>
              </div>
              <div className="modal-footer" style={{justifyContent: "space-around"}}>
                <button
                  className="btn btn-outline-secondary rounded-pill px-4"
                  onClick={() => {
                    resetFilters();
                    setShowFilterModal(false);
                  }}
                >
                  Reset
                </button>
                <button
                  className="btn btn-primary rounded-pill px-4"
                  onClick={applyFilters}
                >
                  Apply
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Add / Edit Modals */}
      <AddStaffModal
        show={showCategoryModal}
        onClose={() => setShowCategoryModal(false)}
        onRoleSelected={handleRoleSelected}
      />

      <AddMaidModal
        show={showFormModal}
        onClose={() => {
          setShowFormModal(false);
          setSelectedRoleForForm(null);
        }}
        initialRole={selectedRoleForForm}
      />

        <EditModal
          show={showEditModal}
          onHide={handleCloseEditModal}
          staffData={staffData}
          staffId={selectedStaffId}
          onSuccess={() => {
            fetchServiceStaffList(selectedRoleId);   
    
          }}
        />

        <TransitReport
        showTransit={showTransit}
        setShowTransit={setShowTransit}
        roleId={selectedRoleId}
        role={selectedRole}
        />

        <DigitalPassCard
          show={showDigitalPass}
          onHide={() => {
            setShowDigitalPass(false);
            setDigitalPassData(null);
          }}
          loading={loadingPass}
          staffData={digitalPassData}
        />
        <ImagePreviewModal
          show={!!selectedStaffForImage}
          imageUrl={selectedStaffForImage?.userImageURL}
          onClose={() => setSelectedStaffForImage(null)}
          title={selectedStaffForImage?.userName}
        />
      {/* Backdrops */}
      {(showListModal || showFilterModal) && <div className="modal-backdrop fade show" />}
      {showCategoryModal && <div className="modal-backdrop fade show" />}
      {showFormModal && <div className="modal-backdrop fade show" style={{ zIndex: 1050 }} />}
    </>
    
  );
};

export default ServiceStaff;